
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.882 3.317a.4.4 0 10-.565.566L9.434 10l-6.118 6.117a.4.4 0 10.566.566L10 10.566l6.117 6.117a.4.4 0 00.566-.566L10.565 10l6.117-6.117a.4.4 0 00-.566-.566L10 9.434 3.882 3.317z","fill":"#101010"}})])
      }
    
      }
    